// Rajesh 11/25/2022 2700423152 trigger execution table.
// Suresh Peddavoora 11/28/2022 2700423152 Modified Table Styles and Table Pagination
// Sai krishna 12/02/2022 2701350359 Added history execution popup.
// Saikrishna 12/02/2022 3031450488 execution done.
// Saikrishna 12/03/2022 3031450488 execution bugs fixed.
// Sai maheshwar 12/05/2022 3031450488 fixed time conversion issue
// Sai maheshwar 12/05/2022 3031450488 fixed time conversion issue
// akhila 12/05/2022 3031450488 used condition for report parameter.
// Rajesh 12/14/2022 3031450488 added file name column in execution
// Raghu 12/22/2022 3031450488 Table Footer Stylings
// Dilip 12/26/2022 3031450488 added error message column
// sai krisna 12/27/2022  3031450488 add download Icon for download recored
// Suresh Peddavoora 12/28/2022 3031450488 Fixed Table Column Spacing Alignments
// Dilip 12/26/2022 3031450488 added BredCrums to show woekqueue
// Dilip 12/26/2022 3031450488 Conditional rendering of BredCrums to show woekqueue code
// Dilip 12/26/2022 3031450488 added BredCrums to show woekqueue description
// suresh peddavoora 02/24/2023 3031450488 New UI changes

// Ravi 02/24/2023 3031450488 implemented previewFile in download Configuration
// Akhila 03/02/2023 3031450488 Added loader and download toast message for preview File
// Akhila 05/10/2023 3031450488 modified download for excel file in execution
// Prakash 29/06/2023 3031450488 add pop up tooltip
// Akhila 06/07/2023 3031450488 Added code and description

import React, {createRef, useState, useEffect} from 'react';
import {TablePagination, Tooltip} from '@material-ui/core';
import {useDispatch, useSelector} from 'react-redux';
import {defaultRows} from '../../../../constants/ReusableTablePagination';
import GuiTable from '../../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../../constants/ReusableConstants';
import PageLoader from '../../../../components/PageLoader';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import {
  fetchExecutionReportData,
  resetMessage,
  resetExecution,
} from '../../../../redux/reducers/ReportMaster';
import axios from 'axios';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../components/CustomSnackBar';
import {
  postGenerateUrl,
  resetConfigUrl,
  resetDockey,
} from '../../../../redux/reducers/BRE/AddReportMaster';
import BreadCrums from '../../../../util/BreadCrum';
import PreviewFileDialog from '../../../../util/PreviewFileDialog';
import {fetchDownloadSuccess, resetDownloadMsg} from '../../../../redux/reducers/PreviewFileData';
import {
  fetchDownloadSuccess1,
  ResetExecelSucessMsg as resetExecelSucessMsg,
} from '../../../../redux/reducers/BRE/AddReportMaster';

const ReportsExecutionTable = ({executionRowData, workQueue, reportExecution}) => {
  const tableRef = createRef();
  const [configOpen, setConfigOpen] = useState(false);
  const [configData, setConfigData] = useState(null);
  const [isLoadingPrint, setIsLoadingPrint] = useState(false);
  const moment = require('moment-timezone');
  const columns = [
    {
      title: 'File Name',
      field: 'fileName',
      render: (rowData) => (
        <span
        // role="button"
        // className={`table-word-wrap-border ${classes1.link}`}
        // onClick={() => {
        //   dispatch(
        //     postGenerateUrl({
        //       dockey: rowData?.documentKey,
        //     })
        //   );
        // }}
        >
          {rowData.fileName ? rowData.fileName : ''}
        </span>
      ),
    },
    {
      title: 'Status',
      field: 'status',
      render: (rowData) => (
        <span
          style={{color: ['Success', 'SUCCESS'].includes(rowData.status) ? '#00af00' : '#FA113D'}}
        >
          {rowData.status}
        </span>
      ),
    },
    {
      title: 'Start Time',
      field: 'startDttm',
      render: (rowData) => (
        <>
          {rowData?.startDttm &&
            moment(rowData.startDttm).tz('America/New_York').format('MM/DD/YYYY h:mm:ss A')}
        </>
      ),
    },
    {
      title: 'End Time',
      field: 'endDttm',
      render: (rowData) => (
        <>
          {/* {rowData?.endDttm && moment.utc(rowData.endDttm).format("l LT")} */}
          {rowData?.endDttm &&
            moment(rowData.endDttm).tz('America/New_York').format('MM/DD/YYYY h:mm:ss A')}
        </>
      ),
    },
    {
      title: 'Total Accounts',
      field: 'recordCount',
    },
    {
      title: 'Executed By',
      field: 'executedBy',
    },
    {
      title: workQueue ? 'Work Queue Parameters' : 'Report Parameters',
      cellStyle: {
        minWidth: 350,
        maxWidth: 350,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      render: (rowData) => {
        return (
          <Tooltip title={rowData?.reportParameters?.split(',').join(', ')} interactive>
            <p className="popup-text">{rowData?.reportParameters?.split(',').join(', ')}</p>
          </Tooltip>
        );
      },
      // field: "reportParameters",
      // render: (rowData) => (
      //   <>
      //     <div
      //       style={{
      //         maxWidth: 300,
      //         textAlign: "justify",
      //         whiteSpace: "normal",
      //         wordWrap: "break-word",
      //       }}
      //     >
      //       {rowData?.reportParameters}
      //     </div>
      //   </>
      // ),
    },
    {
      title: 'Error Message',
      field: 'errorMessage',
      cellStyle: {
        minWidth: 350,
        maxWidth: 350,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      render: (rowData) => {
        return (
          <Tooltip title={rowData?.errorMessage?.split(',').join(', ')} interactive>
            <p className="popup-text">{rowData?.errorMessage?.split(',').join(', ')}</p>
          </Tooltip>
        );
      },
      // render: (rowData) => <span style={{ whiteSpace: "pre-wrap" }}>{rowData.errorMessage}</span>,
    },
  ];
  const {isLoading, executionData, successMsg, errorMsg, configurationUrl, dockey} = useSelector(
    ({reportMaster}) => reportMaster,
  );
  const dispatch = useDispatch();
  const [rows, setRows] = useState(defaultRows);

  //   const { triggerExecutionData, isLoading } = useSelector(({ addTriggerGroup }) => addTriggerGroup);
  const executionDataTable =
    executionData && executionData?.length > 0 ?
      executionData?.map((item) => ({
        ...item,
      })) :
      [];
  useEffect(() => {
    dispatch(fetchExecutionReportData(executionRowData?.reportId));
    return () => {
      dispatch(resetMessage());
      dispatch(resetExecution());
    };
  }, []);
  useEffect(() => {
    if (configurationUrl) {
      setIsLoadingPrint(true);
      async function readData() {
        setConfigOpen(true);
        const data = await axios({
          url: configurationUrl,
          method: 'GET',
        });
        setConfigData(data);
        setIsLoadingPrint(false);
      }
      readData();
    }
  }, [configurationUrl]);
  const handleConfigClose = () => {
    setConfigOpen(false);
    dispatch(resetConfigUrl());
    dispatch(resetDockey());
    dispatch(resetDownloadMsg());
    dispatch(resetExecelSucessMsg());
  };
  return (
    <div className="global-field-table custom-table col-12 new-standard-textfields popup-block">
      <BreadCrums
        name={'Name'}
        code={executionRowData?.reportCode}
        description={'Description'}
        descriptionValue={executionRowData?.reportDescription}
      />
      <PreviewFileDialog
        open={configOpen}
        dialogClose={handleConfigClose}
        fileUrl={configurationUrl}
        configData={configData}
        dockey={dockey}
        moduleName={'Reporting/Export'}
      />
      <GuiTable
        title=""
        columns={columns}
        tableRef={tableRef}
        data={executionDataTable}
        actions={[
          (rowData) => {
            if (rowData?.documentKey) {
              return {
                icon: () => <GetAppOutlinedIcon />,
                tooltip: 'Download',
                onClick: (event, rowData) => {
                  dispatch(
                    postGenerateUrl({
                      dockey: rowData?.documentKey,
                    }),
                  );
                  {
                    workQueue ?
                      dispatch(
                        fetchDownloadSuccess({
                          response: 'Work Queue Execution Downloaded Successfully',
                        }),
                      ) :
                      dispatch(
                        fetchDownloadSuccess({
                          response: 'Report Execution Downloaded Successfully',
                        }),
                      );
                  }
                  {
                    rowData?.outputType === 'Excel' && !workQueue ?
                      dispatch(
                        fetchDownloadSuccess1({
                          response: 'Report Execution Downloaded Successfully',
                        }),
                      ) :
                      rowData?.outputType === 'Excel' && workQueue ?
                        dispatch(
                          fetchDownloadSuccess1({
                            response: 'Work Queue Execution Downloaded Successfully',
                          }),
                        ) :
                        null;
                  }
                },
              };
            }
          },
        ]}
        options={{
          search: false,
          pageSize: rows,
          showSelectAllCheckbox: false,
          emptyRowsWhenPaging: false,
          toolbar: false,
          pageSizeOptions: tablePageRows,
          headerStyle: {
            fontWeight: 'bold',
          },
        }}
        components={{
          Pagination: (props) => (
            <div className="global-field-table-footer">
              <TablePagination
                {...props}
                SelectProps={{
                  inputProps: {'aria-label': 'Rows per screen'},
                }}
                labelRowsPerPage={'Rows per screen:'}
                rowsPerPageOptions={tablePageRows}
                onChangeRowsPerPage={(event) => {
                  props.onChangeRowsPerPage(event);
                  setRows(event.target.value);
                }}
              />
            </div>
          ),
        }}
      />
      {isLoadingPrint && <PageLoader />}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
      {isLoading && <PageLoader />}
    </div>
  );
};

export default ReportsExecutionTable;
